import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import FormikDropdown from "../../components/inputFields/FormikDropDown";

const itemOptions = [
    { value: "item1", label: "Item 1" },
    { value: "item2", label: "Item 2" },
    { value: "item3", label: "Item 3" },
];

const ReportDamageSchema = Yup.object().shape({
    itemName: Yup.string().required("Required"),
    itemId: Yup.string().required("Required"),
    date: Yup.date().required("Required"),
    description: Yup.string().required("Required"),
    photo: Yup.mixed(),
    reportedBy: Yup.string(),
});

const ReportDamageForm = () => {
    return (
        <>
            {/* Header */}
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-900 mb-2">Report Damage</h1>
                <p className="text-gray-600">Submit a damage report for inventory items</p>
            </div>

            {/* Form Card */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <Formik
                    initialValues={{
                        itemName: "",
                        itemId: "",
                        date: "",
                        description: "",
                        photo: null,
                        reportedBy: "",
                    }}
                    validationSchema={ReportDamageSchema}
                    onSubmit={(values) => {
                        console.log("Report Damage Submitted:", values);
                    }}
                >
                    {({ setFieldValue, errors, touched }) => (
                        <Form className="space-y-6">
                            {/* Item Details Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <FormikDropdown
                                    label="Item Name"
                                    name="itemName"
                                    options={itemOptions}
                                    required
                                    height={36}
                                />
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Item ID/Code<span className="text-red-500 ml-1">*</span>
                                    </label>
                                    <Field
                                        name="itemId"
                                        className="w-full h-9 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                        placeholder="Enter Item ID or Code"
                                    />
                                    {touched.itemId && errors.itemId && (
                                        <div className="text-red-500 text-xs mt-1">{errors.itemId}</div>
                                    )}
                                </div>
                            </div>

                            {/* Date and Reporter Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Date of Damage<span className="text-red-500 ml-1">*</span>
                                    </label>
                                    <Field
                                        name="date"
                                        type="date"
                                        className="w-full h-9 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                    />
                                    {touched.date && errors.date && (
                                        <div className="text-red-500 text-xs mt-1">{errors.date}</div>
                                    )}
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Reported By
                                    </label>
                                    <Field
                                        name="reportedBy"
                                        className="w-full h-9 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                        placeholder="Your Name (optional)"
                                    />
                                </div>
                            </div>

                            {/* Description */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Description<span className="text-red-500 ml-1">*</span>
                                </label>
                                <Field
                                    as="textarea"
                                    name="description"
                                    rows={3}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                                    placeholder="Describe the damage in detail..."
                                />
                                {touched.description && errors.description && (
                                    <div className="text-red-500 text-xs mt-1">{errors.description}</div>
                                )}
                            </div>

                            {/* Photo Upload */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Upload Photo
                                </label>
                                <div className="border-2 border-dashed border-gray-300 rounded-md p-4 hover:border-gray-400 transition-colors">
                                    <input
                                        name="photo"
                                        type="file"
                                        accept="image/*"
                                        className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                                        onChange={(event) => {
                                            setFieldValue("photo", event.currentTarget.files[0]);
                                        }}
                                    />
                                    <p className="text-xs text-gray-500 mt-1">PNG, JPG, JPEG up to 10MB</p>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="flex justify-end pt-4 border-t border-gray-200">
                                <button
                                    type="submit"
                                    className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                                >
                                    Submit Report
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    );
};

export default ReportDamageForm; 